export const getUserPermissions = (user) => {
  if (!user) return [];
  return Array.isArray(user.permissions) ? user.permissions : [];
};

export const hasPermission = (user, permission) => {
  if (!user) return false;
  if (user.is_owner) return true;
  return getUserPermissions(user).includes(permission);
};

export const hasAnyPermission = (user, permissions = []) => {
  if (!user) return false;
  if (user.is_owner) return true;
  return permissions.some((permission) => hasPermission(user, permission));
};
